module.exports = __webpack_public_path__ + "static/media/LK_Customer Care.d060acd3.svg";